var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4926_19147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6018 5.15313C19.4888 4.72764 19.2659 4.33931 18.9556 4.027C18.6453 3.7147 18.2584 3.48938 17.8337 3.37358C16.27 2.95313 10.02 2.95312 10.02 2.95312C10.02 2.95312 3.77002 2.95313 2.20638 3.37358C1.78163 3.48938 1.39474 3.7147 1.08443 4.027C0.774116 4.33931 0.551274 4.72764 0.438201 5.15313C0.0200196 6.72358 0.0200195 9.99858 0.0200195 9.99858C0.0200195 9.99858 0.0200196 13.2736 0.438201 14.844C0.551274 15.2695 0.774116 15.6578 1.08443 15.9702C1.39474 16.2825 1.78163 16.5078 2.20638 16.6236C3.77002 17.044 10.02 17.044 10.02 17.044C10.02 17.044 16.27 17.044 17.8337 16.6236C18.2584 16.5078 18.6453 16.2825 18.9556 15.9702C19.2659 15.6578 19.4888 15.2695 19.6018 14.844C20.02 13.2736 20.02 9.99858 20.02 9.99858C20.02 9.99858 20.02 6.72358 19.6018 5.15313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97461 12.9751V7.02734L13.2019 10.0012L7.97461 12.9751Z",
    fill: "#EC4E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4926_19147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ff5764507729195030ed8b227ecfb5c1.svg";
export { ForwardRef as ReactComponent };